import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ApiService from "../api/ApiService";

interface MovieListEntry {
  id: string;
  createdBy: string;
  movieList: string[];
}

interface MovieListResponse {
  statusCode: number;
  data?: MovieListEntry[];
  message?: string;
}

interface LocationState {
  fromSource?: string;
}

const MoviesPage = () => {

  const [movies, setMovies] = useState<MovieListEntry[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");

  const location = useLocation();
  const { fromSource } = (location.state as LocationState) || {};

  const fetchMovies = async () => {
    try {
      const res: MovieListResponse = await ApiService.getAllMovieLists();

      if (res.statusCode === 200 && res.data) {
        setMovies(res.data);
      } else {
        setError(res.message || "Failed to fetch movies");
      }
    } catch (err: any) {
      setError(err.response?.data?.message || "Error fetching movies");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMovies();
  }, []);

  return (
    <>
      <header className="welcome-banner">
        <div className="banner-content">
          <h1 className="welcome">Welcome!</h1>
          <h2 className="title">Favorite Movies</h2>

          <p className="description">
            Everyone likes movies! This is a site where you can add your own
            favorite movies, and see all the favorite movies of your friends!
          </p>

          <p className="description">
            Want to add your own list of favorite movies?{" "}
            <Link to="/my-movies">Click here</Link>
          </p>

          <p className="subtitle">
            See below for each person's top 10 favorite movies of all time!
          </p>
        </div>
      </header>

      {isLoading ? (
        <div className="spinner"></div>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : (
        <>
          {fromSource && <p className="success-message">{fromSource}</p>}

          <div className="movie-list-container">
            {movies.map((entry) => (
              <div className="movie-list-card" key={entry.id}>
                <h2>{entry.createdBy}</h2>
                <ol>
                  {entry.movieList.map((movie, index) => (
                    <li key={index}>{movie}</li>
                  ))}
                </ol>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default MoviesPage;
